// extracted by mini-css-extract-plugin
export var root = "PlasmicCopyright-module--root--28954";
export var rootinverted = "PlasmicCopyright-module--rootinverted--263c4";
export var slotTargetText = "PlasmicCopyright-module--slotTargetText--61928";
export var slotTargetTextinverted = "PlasmicCopyright-module--slotTargetTextinverted--17939";